export default __webpack_public_path__ + "static/media/map_final_ocean.917e93d6.jpg";